/**
 * Names of sounds
 */
export default class SoundVars {

    static BUTTON_SPIN = "play_btn";
    static BUTTON_CLICK = "but_click";
    static BUTTON_INCREASE = "button-increase";
    static BUTTON_DECREASE = "button-decrease";
    static BUTTON_HELP_OPEN = "help-open";
    static BUTTON_HELP_CLOSE = "help-close";

    static MUSIC_MAIN = "backgroundMusic";
    static MUSIC_MAIN2 = "backgroundMusic2";
    static MUSIC_MAIN3 = "backgroundMusic3";
    static MUSIC_BONUS = "bonusBackgroundMusic";
    static MUSIC_FREE_SPINS = "fsBackgroundMusic";
    static MUSIC_BIGWIN = "bigWinMusic";
    

    static EFFECT_CASCADE_FALL = "cascade_reel_fall";
    static EFFECT_CASCADE_FALL_SECONDARY = "cascade_reel_fall_secondary";
    static EFFECT_REEL_SPIN = "reel_run";
    static EFFECT_REEL_START = "reels_start";
    static EFFECT_REEL_STOP = "reel_stop";
    static EFFECT_REEL_QUICK_STOP = "reel_quick_stop";
    static EFFECT_REEL_SCATTER = "reel_stop_scatter";
    static EFFECT_REEL_ANTICIPATION = "reel_anticipation";
    static EFFECT_TAKEWIN = "take_win";
    static EFFECT_TAKEWIN_ABOVE = "take_win_above";
    static EFFECT_TAKEWIN_BELOW = "take_win_below";
    static EFFECT_WINCOUNT = "win_counter";
    static EFFECT_SYMBOLPOP = "symbolPop";
    static EFFECT_MULTIPLIER = "multiplier";
    static EFFECT_SHOWWIN = "show_win";
    static EFFECT_ALARM = "alarm";
    static EFFECT_SWITCH_TO_MAIN: string = "switchToMain";
    static EFFECT_SWITCH_TO_NEXT: string = "switchToNext";


    static BIG_WIN_COMPLETE = "big_win_complete";
    static WIN_BIGWIN = "win_big";
    static WIN_SYMBOL5 = "win_big";
    static WIN_SYMBOL4 = "win_epic";
    static WIN_SYMBOL3 = "win_mega";
    static WIN_SYMBOL2 = "win_medium";
    static WIN_SYMBOL1 = "win_medium1";
    static WIN_SYMBOL0 = "win_small";
    static WIN_LINE = "win_line";

    static SPLASH_SHOW = "splash_show";
    static WILD_EXPAND = "wild_expand";

}
